import { ROUTE_PATHS } from 'core/constants/routePath'
import { TagsAdmin } from 'lauria/components/tags/TagsAdmin'
import { CurrentTagProvider } from 'lauria/contexts/CurrentTagContext'
import { useMyPermissions } from 'core/hooks/useMyPermissions'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

export const Tags = () => {
  const navigate = useNavigate()
  const { isSuperAdmin } = useMyPermissions()

  useEffect(() => {
    if (!isSuperAdmin) {
      navigate(ROUTE_PATHS.DASHBOARD)
    }
  }, [isSuperAdmin, navigate])

  if (!isSuperAdmin) {
    return null
  }
  return (
    <CurrentTagProvider>
      <TagsAdmin />
    </CurrentTagProvider>
  )
}
